import React from "react";
import { HubContextMenu } from "../../components";
import { useDeleteShipmentById } from "../../hooks";
import { setIsOpenDialog } from "../../redux";
import { connect } from "react-redux";

const MENU_ITEMS = [
  {
    id: "edit",
    label: "Edit",
    icon: "Edit",
  },
  {
    id: "delete",
    label: "Delete",
    icon: "Trash2",
    color: "redError",
  },
];

const mapStateToProps = () => {};
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};
export const ShipmentOrdersContextMenu = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ item, _setIsOpenDialog = () => {} }) => {
  const id = item?.id;
  const { mutate: deleteShipmentById } = useDeleteShipmentById();

  const onSelect = (item) => {
    switch (item?.id) {
      case "edit":
        _setIsOpenDialog("edit-shipping-details", id);
        break;
      case "delete":
        deleteShipmentById(id);
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"shipping-details"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: "0px !important" } }}
      HubIconProps={{ size: 14 }}
    />
  );
});

export default ShipmentOrdersContextMenu;
